export const TWITTER_SITE = 'khanoumi_shop'
export const TWITTER_CREATOR = 'khanoumi_shop'
